import { LeadForm, LeadMagnetSuccessModal, ResultTier } from '@/types/lead-magnet';

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

const distanceToTier = (score: number, tier: ResultTier) =>
	Math.abs(score - clamp(score, tier.minScore, tier.maxScore));

export const getResultTier = (score: number, tiers: ResultTier[]): ResultTier | null => {
	if (!tiers?.length) return null;

	const exact = tiers.find(tier => score >= tier.minScore && score <= tier.maxScore);

	if (exact) return exact;

	const [nearest] = [...tiers].sort((a, b) => distanceToTier(score, a) - distanceToTier(score, b));

	console.warn(
		`[lead-magnet] no result tier covers score ${score}, falling back to "${nearest.key}".`
	);

	return nearest;
};

export const getLeadForm = (tier: ResultTier | null, forms: LeadForm[]): LeadForm | null => {
	if (!forms.length) return null;

	if (!tier?.formKey) return forms[0];

	return forms.find(form => form.key === tier.formKey) ?? forms[0];
};

export const getSuccessModal = (
	tier: ResultTier | null,
	entryModal: LeadMagnetSuccessModal | null
) => tier?.successModal ?? entryModal;
